// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "vc.uincubator.api",
    name: "UIIC",
    homepage: "https://api.uincubator.vc/download/?company_id=NTU2NjIwMDA=",
    image_id: "cdd77592-c1ba-4dc2-f2a6-c454e2c19800",
    app: {
        browser: null,
        ios: null,
        android: "https://api.uincubator.vc/download/?company_id=NTU2NjIwMDA=",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "uiwallet://?uri=",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map